import { useForm } from "react-hook-form";
import InvalidFeedback from "../../components/invalid-feedback/invalid-feedback.component";
import { SystemUserService } from "../../services/system-user";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { AlertService } from "../../services/alert.service";

function ResetPasswordPage() {
  const [errorMsg, setErrorMsg] = useState("");

  const defaultValues = {
    email: "",
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

  const submit = async (data: typeof defaultValues) => {
    try {
      await SystemUserService.forgotPassword(data.email);
      AlertService.toastSuccess(`Correo enviado. Revisa tu correo ${data.email}`, 10000);
      reset(defaultValues);

    } catch (error: any) {
      setErrorMsg(error);
    }
  };

  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-column flex-lg-row-fluid py-10">
          <div className="d-flex flex-center flex-column flex-column-fluid">
            <div className="w-lg-500px p-10 p-lg-15 mx-auto">
              <div className="form w-100">
                <div className="text-center mb-10">
                  <img
                    alt="Aguacatecnia"
                    className="h-100px mb-7"
                    src="/assets/media/logos/logo-default.svg"
                  />
                  <h1 className="text-gray-900 mb-3">Contraseña olvidada</h1>
                  <div className="text-gray-500 fw-semibold fs-4">
                    Introduce la dirección de correo electrónico asociada a tu
                    cuenta y te enviaremos un vínculo para restablecer tu
                    contraseña.
                  </div>
                </div>

                {errorMsg && (
                  <div className="alert alert-danger mb-7">{errorMsg}</div>
                )}

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bold text-gray-900 fs-6 mb-0">
                      Correo
                    </label>
                  </div>
                  <input
                    className={`form-control form-control-lg form-control-solid ${
                      errors.email ? "is-invalid" : ""
                    }`}
                    {...register("email", { required: true })}
                  />
                  <InvalidFeedback error={errors.email} />
                </div>

                <div className="text-center">
                  <button
                    className="btn btn-lg btn-primary w-100 mb-5"
                    disabled={!isValid || isSubmitting}
                    onClick={handleSubmit(submit)}
                  >
                    {isSubmitting ? (
                      <span className="indicator-progress d-block">
                        Espere por favor...
                        <span className="spinner-border spinner-border-sm align-middle ms-2" />
                      </span>
                    ) : (
                      <span className="indicator-label">
                        Restablecer contraseña
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
